import * as $runtime from "../runtime.js";
import * as Data$dArray$dNonEmpty$dSerialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dMultiSet$dSerialized from "../Data.MultiSet.Serialized/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $FatalError = (tag, _1, _2) => ({tag, _1, _2});
const $SimpleParametricEvaluationError = (tag, _1) => ({tag, _1});
const $SoftError = (tag, _1, _2) => ({tag, _1, _2});
const ParameterChoiceNotAvailable = value0 => $SoftError("ParameterChoiceNotAvailable", value0);
const InvalidModifierItemCount = value0 => $SoftError("InvalidModifierItemCount", value0);
const InvalidModifierItemDuplicateCount = value0 => value1 => $SoftError("InvalidModifierItemDuplicateCount", value0, value1);
const ModifierItemNotAvailable = value0 => value1 => $SoftError("ModifierItemNotAvailable", value0, value1);
const IrremovableModifierItem = value0 => value1 => $SoftError("IrremovableModifierItem", value0, value1);
const ComboNotAvailable = value0 => $SoftError("ComboNotAvailable", value0);
const ProductNotAvailable = value0 => $SoftError("ProductNotAvailable", value0);
const MissingParameters = value0 => $SimpleParametricEvaluationError("MissingParameters", value0);
const MissingValue = /* #__PURE__ */ $SimpleParametricEvaluationError("MissingValue");
const ProductNotFound = value0 => $FatalError("ProductNotFound", value0);
const CategoryNotFound = /* #__PURE__ */ $FatalError("CategoryNotFound");
const DistinctCategories = /* #__PURE__ */ $FatalError("DistinctCategories");
const TooManyParts = /* #__PURE__ */ $FatalError("TooManyParts");
const ParameterNotFound = value0 => $FatalError("ParameterNotFound", value0);
const ParametricError = value0 => $FatalError("ParametricError", value0);
const CustomParameterNotSet = value0 => $FatalError("CustomParameterNotSet", value0);
const InternalParameterNotSet = value0 => $FatalError("InternalParameterNotSet", value0);
const InvalidParameterValue = value0 => $FatalError("InvalidParameterValue", value0);
const ModifierNotFound = value0 => $FatalError("ModifierNotFound", value0);
const ModifierNotSet = value0 => $FatalError("ModifierNotSet", value0);
const InvalidModifierValue = value0 => value1 => $FatalError("InvalidModifierValue", value0, value1);
const ComboNotFound = value0 => $FatalError("ComboNotFound", value0);
const ComboElementNotSet = value0 => value1 => $FatalError("ComboElementNotSet", value0, value1);
const InvalidComboChoice = value0 => value1 => $FatalError("InvalidComboChoice", value0, value1);
const AvailabilityScheduleNotFound = value0 => $FatalError("AvailabilityScheduleNotFound", value0);
const VariantNotAvailable = value0 => $FatalError("VariantNotAvailable", value0);
const PackagingContainerNotFound = value0 => $FatalError("PackagingContainerNotFound", value0);
const CartProductPartKey = x => x;
const CartProductKey = x => x;
const CartComboElementKey = x => x;
const CartComboKey = x => x;
const newtypeCartProductPartKey = {Coercible0: () => {}};
const newtypeCartProductKey_ = {Coercible0: () => {}};
const newtypeCartComboKey_ = {Coercible0: () => {}};
const newtypeCartComboElementKe = {Coercible0: () => {}};
const hasFieldCartProductPartKe = dictHasField => dictHasField;
const hasFieldCartProductKey = dictHasField => dictHasField;
const hasFieldCartComboKey = dictHasField => dictHasField;
const hasFieldCartComboElementK = dictHasField => dictHasField;
const eqSoftError = {
  eq: x => y => {
    if (x.tag === "ParameterChoiceNotAvailable") {
      if (y.tag === "ParameterChoiceNotAvailable") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "InvalidModifierItemCount") {
      if (y.tag === "InvalidModifierItemCount") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "InvalidModifierItemDuplicateCount") {
      if (y.tag === "InvalidModifierItemDuplicateCount") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    if (x.tag === "ModifierItemNotAvailable") {
      if (y.tag === "ModifierItemNotAvailable") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    if (x.tag === "IrremovableModifierItem") {
      if (y.tag === "IrremovableModifierItem") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    if (x.tag === "ComboNotAvailable") {
      if (y.tag === "ComboNotAvailable") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ProductNotAvailable") {
      if (y.tag === "ProductNotAvailable") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const eqSimpleParametricEvaluat = {
  eq: x => y => {
    if (x.tag === "MissingParameters") {
      if (y.tag === "MissingParameters") { return Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.eqParameterId)(Data$dEq.eqUnit).eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "MissingValue") { return y.tag === "MissingValue"; }
    return false;
  }
};
const eqFatalError = {
  eq: x => y => {
    if (x.tag === "ProductNotFound") {
      if (y.tag === "ProductNotFound") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "CategoryNotFound") { return y.tag === "CategoryNotFound"; }
    if (x.tag === "DistinctCategories") { return y.tag === "DistinctCategories"; }
    if (x.tag === "TooManyParts") { return y.tag === "TooManyParts"; }
    if (x.tag === "ParameterNotFound") {
      if (y.tag === "ParameterNotFound") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ParametricError") {
      if (y.tag === "ParametricError") { return eqSimpleParametricEvaluat.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "CustomParameterNotSet") {
      if (y.tag === "CustomParameterNotSet") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "InternalParameterNotSet") {
      if (y.tag === "InternalParameterNotSet") {
        if (x._1.tag === "Origin") { return y._1.tag === "Origin"; }
        if (x._1.tag === "FulfillmentMethod") { return y._1.tag === "FulfillmentMethod"; }
        if (x._1.tag === "PaymentMethod") { return y._1.tag === "PaymentMethod"; }
        if (x._1.tag === "IsDivided") { return y._1.tag === "IsDivided"; }
        if (x._1.tag === "Schedule") {
          if (y._1.tag === "Schedule") { return x._1._1 === y._1._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    if (x.tag === "InvalidParameterValue") {
      if (y.tag === "InvalidParameterValue") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ModifierNotFound") {
      if (y.tag === "ModifierNotFound") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ModifierNotSet") {
      if (y.tag === "ModifierNotSet") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "InvalidModifierValue") {
      if (y.tag === "InvalidModifierValue") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    if (x.tag === "ComboNotFound") {
      if (y.tag === "ComboNotFound") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ComboElementNotSet") {
      if (y.tag === "ComboElementNotSet") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    if (x.tag === "InvalidComboChoice") {
      if (y.tag === "InvalidComboChoice") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    if (x.tag === "AvailabilityScheduleNotFound") {
      if (y.tag === "AvailabilityScheduleNotFound") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "VariantNotAvailable") {
      if (y.tag === "VariantNotAvailable") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "PackagingContainerNotFound") {
      if (y.tag === "PackagingContainerNotFound") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const eqCartProductPartKey = {
  eq: x => y => Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq(x.customParameters)(y.customParameters) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqInt)).eq(x.modifiers)(y.modifiers) && x.productId === y.productId
};
const ordCartProductPartKey = {
  compare: x => y => {
    const v = Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordString).compare(x.customParameters)(y.customParameters);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    const v1 = Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordInt)).compare(x.modifiers)(y.modifiers);
    if (v1.tag === "LT") { return Data$dOrdering.LT; }
    if (v1.tag === "GT") { return Data$dOrdering.GT; }
    return Data$dOrd.ordString.compare(x.productId)(y.productId);
  },
  Eq0: () => eqCartProductPartKey
};
const eqCartProductKey = {
  eq: x => y => Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq(x.customParameters)(y.customParameters) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqInt)).eq(x.modifiers)(y.modifiers) && Data$dEq.eqArrayImpl(eqCartProductPartKey.eq)(x.parts)(y.parts)
};
const ordCartProductKey = {
  compare: x => y => {
    const v = Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordString).compare(x.customParameters)(y.customParameters);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    const v1 = Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordInt)).compare(x.modifiers)(y.modifiers);
    if (v1.tag === "LT") { return Data$dOrdering.LT; }
    if (v1.tag === "GT") { return Data$dOrdering.GT; }
    return Data$dOrd.ordArray(ordCartProductPartKey).compare(x.parts)(y.parts);
  },
  Eq0: () => eqCartProductKey
};
const eqCartComboElementKey = {
  eq: x => y => x.comboChoiceId === y.comboChoiceId && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq(x.customParameters)(y.customParameters) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqInt)).eq(x.modifiers)(y.modifiers)
};
const eqCartComboKey = {eq: x => y => x.comboId === y.comboId && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(eqCartComboElementKey).eq(x.elements)(y.elements)};
const ordCartComboElementKey = {
  compare: x => y => {
    const v = Data$dOrd.ordString.compare(x.comboChoiceId)(y.comboChoiceId);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    const v1 = Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordString).compare(x.customParameters)(y.customParameters);
    if (v1.tag === "LT") { return Data$dOrdering.LT; }
    if (v1.tag === "GT") { return Data$dOrdering.GT; }
    return Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(Data$dOrd.ordInt)).compare(x.modifiers)(y.modifiers);
  },
  Eq0: () => eqCartComboElementKey
};
const ordCartComboKey = {
  compare: x => y => {
    const v = Data$dOrd.ordString.compare(x.comboId)(y.comboId);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    return Data$dMap$dInternal.ordMap(Data$dOrd.ordString)(ordCartComboElementKey).compare(x.elements)(y.elements);
  },
  Eq0: () => eqCartComboKey
};
const genericSoftError = {
  to: x => {
    if (x.tag === "Inl") { return $SoftError("ParameterChoiceNotAvailable", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $SoftError("InvalidModifierItemCount", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $SoftError("InvalidModifierItemDuplicateCount", x._1._1._1._1, x._1._1._1._2); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $SoftError("ModifierItemNotAvailable", x._1._1._1._1._1, x._1._1._1._1._2); }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return $SoftError("IrremovableModifierItem", x._1._1._1._1._1._1, x._1._1._1._1._1._2); }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return $SoftError("ComboNotAvailable", x._1._1._1._1._1._1); }
              if (x._1._1._1._1._1.tag === "Inr") { return $SoftError("ProductNotAvailable", x._1._1._1._1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ParameterChoiceNotAvailable") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "InvalidModifierItemCount") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "InvalidModifierItemDuplicateCount") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2))));
    }
    if (x.tag === "ModifierItemNotAvailable") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2)))));
    }
    if (x.tag === "IrremovableModifierItem") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2)))))
      );
    }
    if (x.tag === "ComboNotAvailable") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
      );
    }
    if (x.tag === "ProductNotAvailable") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)))))
      );
    }
    $runtime.fail();
  }
};
const showSoftError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ParameterChoiceNotAvailable"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "InvalidModifierItemCount"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})({genericShowArgs: v => [v]}))({
      reflectSymbol: () => "InvalidModifierItemDuplicateCount"
    });
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})({genericShowArgs: v => [v]}))({
      reflectSymbol: () => "ModifierItemNotAvailable"
    });
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})({genericShowArgs: v => [v]}))({
      reflectSymbol: () => "IrremovableModifierItem"
    });
    const $5 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ComboNotAvailable"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ProductNotAvailable"});
    return x => {
      const $7 = genericSoftError.from(x);
      if ($7.tag === "Inl") { return $0["genericShow'"]($7._1); }
      if ($7.tag === "Inr") {
        if ($7._1.tag === "Inl") { return $1["genericShow'"]($7._1._1); }
        if ($7._1.tag === "Inr") {
          if ($7._1._1.tag === "Inl") { return $2["genericShow'"]($7._1._1._1); }
          if ($7._1._1.tag === "Inr") {
            if ($7._1._1._1.tag === "Inl") { return $3["genericShow'"]($7._1._1._1._1); }
            if ($7._1._1._1.tag === "Inr") {
              if ($7._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($7._1._1._1._1._1); }
              if ($7._1._1._1._1.tag === "Inr") {
                if ($7._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($7._1._1._1._1._1._1); }
                if ($7._1._1._1._1._1.tag === "Inr") { return $6["genericShow'"]($7._1._1._1._1._1._1); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeSoftError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ParameterChoiceNotAvailable"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "InvalidModifierItemCount"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))})))({reflectSymbol: () => "InvalidModifierItemDuplicateCount"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))})))({reflectSymbol: () => "ModifierItemNotAvailable"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))})))({reflectSymbol: () => "IrremovableModifierItem"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ComboNotAvailable"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ProductNotAvailable"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericSoftError.to($0(x));
  })()
};
const genericSimpleParametricEvaluationError = {
  to: x => {
    if (x.tag === "Inl") { return $SimpleParametricEvaluationError("MissingParameters", x._1); }
    if (x.tag === "Inr") { return MissingValue; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "MissingParameters") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "MissingValue") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showSimpleParametricEvaluationError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.showParameterId);
      return {genericShowArgs: v => [$0.show(v)]};
    })())({reflectSymbol: () => "MissingParameters"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "MissingValue"});
    return x => {
      if (x.tag === "MissingParameters") { return $0["genericShow'"](x._1); }
      if (x.tag === "MissingValue") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeSimpleParametricEvaluationError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "MissingParameters"
    })((() => {
      const $0 = Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.unscrambleDecodeParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId);
      return {unsafeDecodeSingleConstructorArgument: x => $0.unsafeDecode(x.contents)};
    })()))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "MissingValue"})))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $SimpleParametricEvaluationError("MissingParameters", $1._1); }
      if ($1.tag === "Inr") { return MissingValue; }
      $runtime.fail();
    };
  })()
};
const genericFatalError = {
  to: x => {
    if (x.tag === "Inl") { return $FatalError("ProductNotFound", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return CategoryNotFound; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return DistinctCategories; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return TooManyParts; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return $FatalError("ParameterNotFound", x._1._1._1._1._1); }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return $FatalError("ParametricError", x._1._1._1._1._1._1); }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return $FatalError("CustomParameterNotSet", x._1._1._1._1._1._1._1); }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return $FatalError("InternalParameterNotSet", x._1._1._1._1._1._1._1._1); }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return $FatalError("InvalidParameterValue", x._1._1._1._1._1._1._1._1._1); }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $FatalError("ModifierNotFound", x._1._1._1._1._1._1._1._1._1._1); }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $FatalError("ModifierNotSet", x._1._1._1._1._1._1._1._1._1._1._1); }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                            return $FatalError("InvalidModifierValue", x._1._1._1._1._1._1._1._1._1._1._1._1._1, x._1._1._1._1._1._1._1._1._1._1._1._1._2);
                          }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $FatalError("ComboNotFound", x._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                return $FatalError("ComboElementNotSet", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1, x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._2);
                              }
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                  return $FatalError("InvalidComboChoice", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1, x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._2);
                                }
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                    return $FatalError("AvailabilityScheduleNotFound", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                  }
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $FatalError("VariantNotAvailable", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      return $FatalError("PackagingContainerNotFound", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ProductNotFound") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "CategoryNotFound") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "DistinctCategories") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "TooManyParts") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "ParameterNotFound") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))));
    }
    if (x.tag === "ParametricError") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
      );
    }
    if (x.tag === "CustomParameterNotSet") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
        )
      );
    }
    if (x.tag === "InternalParameterNotSet") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
          )
        )
      );
    }
    if (x.tag === "InvalidParameterValue") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
            )
          )
        )
      );
    }
    if (x.tag === "ModifierNotFound") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "ModifierNotSet") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidModifierValue") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2))))
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ComboNotFound") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ComboElementNotSet") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2))))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "InvalidComboChoice") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.$Product(x._1, x._2))))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "AvailabilityScheduleNotFound") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "VariantNotAvailable") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "PackagingContainerNotFound") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))))
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showFatalError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ProductNotFound"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "CategoryNotFound"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DistinctCategories"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "TooManyParts"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ParameterNotFound"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [showSimpleParametricEvaluationError.show(v)]})({reflectSymbol: () => "ParametricError"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "CustomParameterNotSet"});
    const $7 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.showInternalParameterId.show(v)]})({
      reflectSymbol: () => "InternalParameterNotSet"
    });
    const $8 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "InvalidParameterValue"});
    const $9 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ModifierNotFound"});
    const $10 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ModifierNotSet"});
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})({genericShowArgs: v => [v]}))({
      reflectSymbol: () => "InvalidModifierValue"
    });
    const $12 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ComboNotFound"});
    const $13 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})({genericShowArgs: v => [v]}))({
      reflectSymbol: () => "ComboElementNotSet"
    });
    const $14 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [v]})({genericShowArgs: v => [v]}))({
      reflectSymbol: () => "InvalidComboChoice"
    });
    const $15 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "AvailabilityScheduleNotFound"});
    const $16 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "VariantNotAvailable"});
    const $17 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "PackagingContainerNotFound"});
    return x => {
      const $18 = genericFatalError.from(x);
      if ($18.tag === "Inl") { return $0["genericShow'"]($18._1); }
      if ($18.tag === "Inr") {
        if ($18._1.tag === "Inl") { return $1["genericShow'"]($18._1._1); }
        if ($18._1.tag === "Inr") {
          if ($18._1._1.tag === "Inl") { return $2["genericShow'"]($18._1._1._1); }
          if ($18._1._1.tag === "Inr") {
            if ($18._1._1._1.tag === "Inl") { return $3["genericShow'"]($18._1._1._1._1); }
            if ($18._1._1._1.tag === "Inr") {
              if ($18._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($18._1._1._1._1._1); }
              if ($18._1._1._1._1.tag === "Inr") {
                if ($18._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($18._1._1._1._1._1._1); }
                if ($18._1._1._1._1._1.tag === "Inr") {
                  if ($18._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($18._1._1._1._1._1._1._1); }
                  if ($18._1._1._1._1._1._1.tag === "Inr") {
                    if ($18._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($18._1._1._1._1._1._1._1._1); }
                    if ($18._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($18._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($18._1._1._1._1._1._1._1._1._1); }
                      if ($18._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($18._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1); }
                        if ($18._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($18._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($18._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($18._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($18._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if ($18._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $12["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              if ($18._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $13["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $14["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                  if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $15["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $16["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        return $17["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFatalError = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ProductNotFound"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "CategoryNotFound"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "DistinctCategories"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "TooManyParts"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ParameterNotFound"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ParametricError"
    })({unsafeDecodeSingleConstructorArgument: x => unscrambleDecodeSimpleParametricEvaluationError.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "CustomParameterNotSet"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "InternalParameterNotSet"
    })({unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.unscrambleDecodeInternalParameterId.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "InvalidParameterValue"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ModifierNotFound"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ModifierNotSet"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))})))({reflectSymbol: () => "InvalidModifierValue"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "ComboNotFound"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))})))({reflectSymbol: () => "ComboElementNotSet"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
      argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))
    })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => Data$dUUID.udecodeUUID.unsafeDecode(array[offset]))})))({reflectSymbol: () => "InvalidComboChoice"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "AvailabilityScheduleNotFound"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "VariantNotAvailable"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)}))(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "PackagingContainerNotFound"
    })({unsafeDecodeSingleConstructorArgument: x => Data$dUUID.udecodeUUID.unsafeDecode(x.contents)})))))))))))))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericFatalError.to($0(x));
  })()
};
const genericCartProductPartKey = {to: x => x, from: x => x};
const showCartProductPartKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dMultiSet.showMultiSet(Data$dUUID.showUUID));
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["customParameters", $1.show(v.customParameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "modifiers",
              $0.show(v.modifiers)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["productId", v.productId]))([])));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CartProductPartKey"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCartProductPartKey = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "customParameters"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "modifiers"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dMultiSet$dSerialized.udecodeMultiSet(Data$dOrd.ordString)(Data$dUUID.udecodeUUID)))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "productId"
    })(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCartProductKey = {to: x => x, from: x => x};
const showCartProductKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dMultiSet.showMultiSet(Data$dUUID.showUUID));
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["customParameters", $1.show(v.customParameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "modifiers",
              $0.show(v.modifiers)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["parts", "(NonEmptyArray " + Data$dShow.showArrayImpl(showCartProductPartKey.show)(v.parts) + ")"]))([])));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CartProductKey"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCartProductKey = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "customParameters"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "modifiers"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dMultiSet$dSerialized.udecodeMultiSet(Data$dOrd.ordString)(Data$dUUID.udecodeUUID)))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "parts"
    })(Unscramble.decodeNonEmptyArray(unscrambleDecodeCartProductPartKey))(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCartComboKey = {to: x => x, from: x => x};
const genericCartComboElementKey = {to: x => x, from: x => x};
const showCartComboElementKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dMultiSet.showMultiSet(Data$dUUID.showUUID));
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["comboChoiceId", v.comboChoiceId]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "customParameters",
              $1.show(v.customParameters)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["modifiers", $0.show(v.modifiers)]))([])));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CartComboElementKey"});
    return x => $0["genericShow'"](x);
  })()
};
const showCartComboKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(showCartComboElementKey);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["comboId", v.comboId]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["elements", $0.show(v.elements)]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "CartComboKey"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCartComboElementKey = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "comboChoiceId"})(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "customParameters"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({reflectSymbol: () => "modifiers"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dMultiSet$dSerialized.udecodeMultiSet(Data$dOrd.ordString)(Data$dUUID.udecodeUUID)))(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeCartComboKey = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "comboId"})(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "elements"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(unscrambleDecodeCartComboElementKey))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeSoftError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSoftError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ParameterChoiceNotAvailable"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidModifierItemCount"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidModifierItemDuplicateCount"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}));
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ModifierItemNotAvailable"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}));
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "IrremovableModifierItem"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}));
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ComboNotAvailable"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductNotAvailable"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              if (v._1._1._1.tag === "Inl") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              if (v._1._1._1.tag === "Inr") {
                if (v._1._1._1._1.tag === "Inl") {
                  return $4.encodeOpts({
                    sumEncoding: opts.sumEncoding,
                    unwrapSingleConstructors: false,
                    unwrapSingleArguments: opts.unwrapSingleArguments,
                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                    fieldTransform: opts.fieldTransform
                  })(v._1._1._1._1._1);
                }
                if (v._1._1._1._1.tag === "Inr") {
                  if (v._1._1._1._1._1.tag === "Inl") {
                    return $5.encodeOpts({
                      sumEncoding: opts.sumEncoding,
                      unwrapSingleConstructors: false,
                      unwrapSingleArguments: opts.unwrapSingleArguments,
                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                      fieldTransform: opts.fieldTransform
                    })(v._1._1._1._1._1._1);
                  }
                  if (v._1._1._1._1._1.tag === "Inr") {
                    return $6.encodeOpts({
                      sumEncoding: opts.sumEncoding,
                      unwrapSingleConstructors: false,
                      unwrapSingleArguments: opts.unwrapSingleArguments,
                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                      fieldTransform: opts.fieldTransform
                    })(v._1._1._1._1._1._1);
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeSimpleParametricEvaluationError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSimpleParametricEvaluationError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "MissingParameters"})((() => {
      const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.encodeParameterId);
      return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "MissingValue"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          return $1.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeFatalError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericFatalError)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductNotFound"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CategoryNotFound"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "DistinctCategories"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "TooManyParts"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ParameterNotFound"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ParametricError"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeSimpleParametricEvaluationError.encode(v)), Data$dList$dTypes.Nil)
    });
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CustomParameterNotSet"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $7 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InternalParameterNotSet"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.encodeInternalParameterId.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $8 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidParameterValue"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $9 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ModifierNotFound"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $10 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ModifierNotSet"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $11 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidModifierValue"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}));
    const $12 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ComboNotFound"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $13 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ComboElementNotSet"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}));
    const $14 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "InvalidComboChoice"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)}));
    const $15 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AvailabilityScheduleNotFound"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $16 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "VariantNotAvailable"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $17 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PackagingContainerNotFound"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              if (v._1._1._1.tag === "Inl") {
                return $3.encodeOpts({
                  sumEncoding: opts.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: opts.unwrapSingleArguments,
                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                  fieldTransform: opts.fieldTransform
                })(v._1._1._1._1);
              }
              if (v._1._1._1.tag === "Inr") {
                if (v._1._1._1._1.tag === "Inl") {
                  return $4.encodeOpts({
                    sumEncoding: opts.sumEncoding,
                    unwrapSingleConstructors: false,
                    unwrapSingleArguments: opts.unwrapSingleArguments,
                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                    fieldTransform: opts.fieldTransform
                  })(v._1._1._1._1._1);
                }
                if (v._1._1._1._1.tag === "Inr") {
                  if (v._1._1._1._1._1.tag === "Inl") {
                    return $5.encodeOpts({
                      sumEncoding: opts.sumEncoding,
                      unwrapSingleConstructors: false,
                      unwrapSingleArguments: opts.unwrapSingleArguments,
                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                      fieldTransform: opts.fieldTransform
                    })(v._1._1._1._1._1._1);
                  }
                  if (v._1._1._1._1._1.tag === "Inr") {
                    if (v._1._1._1._1._1._1.tag === "Inl") {
                      return $6.encodeOpts({
                        sumEncoding: opts.sumEncoding,
                        unwrapSingleConstructors: false,
                        unwrapSingleArguments: opts.unwrapSingleArguments,
                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                        fieldTransform: opts.fieldTransform
                      })(v._1._1._1._1._1._1._1);
                    }
                    if (v._1._1._1._1._1._1.tag === "Inr") {
                      if (v._1._1._1._1._1._1._1.tag === "Inl") {
                        return $7.encodeOpts({
                          sumEncoding: opts.sumEncoding,
                          unwrapSingleConstructors: false,
                          unwrapSingleArguments: opts.unwrapSingleArguments,
                          unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                          fieldTransform: opts.fieldTransform
                        })(v._1._1._1._1._1._1._1._1);
                      }
                      if (v._1._1._1._1._1._1._1.tag === "Inr") {
                        if (v._1._1._1._1._1._1._1._1.tag === "Inl") {
                          return $8.encodeOpts({
                            sumEncoding: opts.sumEncoding,
                            unwrapSingleConstructors: false,
                            unwrapSingleArguments: opts.unwrapSingleArguments,
                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                            fieldTransform: opts.fieldTransform
                          })(v._1._1._1._1._1._1._1._1._1);
                        }
                        if (v._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (v._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                            return $9.encodeOpts({
                              sumEncoding: opts.sumEncoding,
                              unwrapSingleConstructors: false,
                              unwrapSingleArguments: opts.unwrapSingleArguments,
                              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                              fieldTransform: opts.fieldTransform
                            })(v._1._1._1._1._1._1._1._1._1._1);
                          }
                          if (v._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (v._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                              return $10.encodeOpts({
                                sumEncoding: opts.sumEncoding,
                                unwrapSingleConstructors: false,
                                unwrapSingleArguments: opts.unwrapSingleArguments,
                                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                fieldTransform: opts.fieldTransform
                              })(v._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            if (v._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (v._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                return $11.encodeOpts({
                                  sumEncoding: opts.sumEncoding,
                                  unwrapSingleConstructors: false,
                                  unwrapSingleArguments: opts.unwrapSingleArguments,
                                  unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                  fieldTransform: opts.fieldTransform
                                })(v._1._1._1._1._1._1._1._1._1._1._1._1);
                              }
                              if (v._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (v._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                  return $12.encodeOpts({
                                    sumEncoding: opts.sumEncoding,
                                    unwrapSingleConstructors: false,
                                    unwrapSingleArguments: opts.unwrapSingleArguments,
                                    unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                    fieldTransform: opts.fieldTransform
                                  })(v._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                }
                                if (v._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                    return $13.encodeOpts({
                                      sumEncoding: opts.sumEncoding,
                                      unwrapSingleConstructors: false,
                                      unwrapSingleArguments: opts.unwrapSingleArguments,
                                      unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                      fieldTransform: opts.fieldTransform
                                    })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                  }
                                  if (v._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $14.encodeOpts({
                                        sumEncoding: opts.sumEncoding,
                                        unwrapSingleConstructors: false,
                                        unwrapSingleArguments: opts.unwrapSingleArguments,
                                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                        fieldTransform: opts.fieldTransform
                                      })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $15.encodeOpts({
                                          sumEncoding: opts.sumEncoding,
                                          unwrapSingleConstructors: false,
                                          unwrapSingleArguments: opts.unwrapSingleArguments,
                                          unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                          fieldTransform: opts.fieldTransform
                                        })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $16.encodeOpts({
                                            sumEncoding: opts.sumEncoding,
                                            unwrapSingleConstructors: false,
                                            unwrapSingleArguments: opts.unwrapSingleArguments,
                                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                            fieldTransform: opts.fieldTransform
                                          })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if (v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          return $17.encodeOpts({
                                            sumEncoding: opts.sumEncoding,
                                            unwrapSingleConstructors: false,
                                            unwrapSingleArguments: opts.unwrapSingleArguments,
                                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                                            fieldTransform: opts.fieldTransform
                                          })(v._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeCartProductPartKey = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCartProductPartKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CartProductPartKey"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "productId"
    })({encodeWithOptions: v => Data$dUUID.encodeUUID.encode}))({reflectSymbol: () => "modifiers"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dMultiSet$dSerialized.encodeMultiSet(Data$dUUID.encodeUUID))((() => {
        const $0 = Data$dMultiSet$dSerialized.encodeMultiSet(Data$dUUID.encodeUUID);
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "customParameters"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCartProductKey = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCartProductKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CartProductKey"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "parts"
    })((() => {
      const $0 = Data$dFunctor.arrayMap(encodeCartProductPartKey.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "modifiers"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dMultiSet$dSerialized.encodeMultiSet(Data$dUUID.encodeUUID))((() => {
        const $0 = Data$dMultiSet$dSerialized.encodeMultiSet(Data$dUUID.encodeUUID);
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "customParameters"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCartComboElementKey = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCartComboElementKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CartComboElementKey"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "modifiers"
    })((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dMultiSet$dSerialized.encodeMultiSet(Data$dUUID.encodeUUID))((() => {
        const $0 = Data$dMultiSet$dSerialized.encodeMultiSet(Data$dUUID.encodeUUID);
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "customParameters"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "comboChoiceId"})({encodeWithOptions: v => Data$dUUID.encodeUUID.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCartComboKey = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCartComboKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CartComboKey"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "elements"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(encodeCartComboElementKey)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeCartComboElementKey.encode(v)), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "comboId"})({encodeWithOptions: v => Data$dUUID.encodeUUID.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeSoftError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSoftError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ParameterChoiceNotAvailable"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidModifierItemCount"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidModifierItemDuplicateCount"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ModifierItemNotAvailable"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "IrremovableModifierItem"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ComboNotAvailable"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductNotAvailable"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))))))))
};
const decodeSimpleParametricEvaluationError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSimpleParametricEvaluationError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "MissingParameters"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Restaumatic$dMenu$dV2$dTypes$dParameterId.decodeParameterId);
    return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
  })())(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "MissingValue"})(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))
};
const decodeFatalError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericFatalError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductNotFound"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CategoryNotFound"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "DistinctCategories"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "TooManyParts"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ParameterNotFound"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ParametricError"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeSimpleParametricEvaluationError.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CustomParameterNotSet"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InternalParameterNotSet"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({
      decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.decodeInternalParameterId.decode
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidParameterValue"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ModifierNotFound"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ModifierNotSet"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidModifierValue"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ComboNotFound"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ComboElementNotSet"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "InvalidComboChoice"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsProduct({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "AvailabilityScheduleNotFound"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "VariantNotAvailable"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PackagingContainerNotFound"
  })({decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing})(Foreign$dGeneric$dClass.genericCountArgsArgument)))))))))))))))))))
};
const decodeCartProductPartKey = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCartProductPartKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CartProductPartKey"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "productId"
  })({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())({reflectSymbol: () => "modifiers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dMultiSet$dSerialized.decodeMultiSet(Data$dOrd.ordString)(Data$dUUID.decodeUUID))((() => {
      const $0 = Data$dMultiSet$dSerialized.decodeMultiSet(Data$dOrd.ordString)(Data$dUUID.decodeUUID);
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "customParameters"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCartProductKey = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCartProductKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CartProductKey"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "parts"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dArray$dNonEmpty$dSerialized.decodeNonEmptyArray(decodeCartProductPartKey);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifiers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dMultiSet$dSerialized.decodeMultiSet(Data$dOrd.ordString)(Data$dUUID.decodeUUID))((() => {
      const $0 = Data$dMultiSet$dSerialized.decodeMultiSet(Data$dOrd.ordString)(Data$dUUID.decodeUUID);
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "customParameters"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCartComboElementKey = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCartComboElementKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CartComboElementKey"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "modifiers"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dMultiSet$dSerialized.decodeMultiSet(Data$dOrd.ordString)(Data$dUUID.decodeUUID))((() => {
      const $0 = Data$dMultiSet$dSerialized.decodeMultiSet(Data$dOrd.ordString)(Data$dUUID.decodeUUID);
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "customParameters"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "comboChoiceId"})({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCartComboKey = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCartComboKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CartComboKey"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "elements"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(decodeCartComboElementKey)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeCartComboElementKey.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "comboId"})({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $FatalError,
  $SimpleParametricEvaluationError,
  $SoftError,
  AvailabilityScheduleNotFound,
  CartComboElementKey,
  CartComboKey,
  CartProductKey,
  CartProductPartKey,
  CategoryNotFound,
  ComboElementNotSet,
  ComboNotAvailable,
  ComboNotFound,
  CustomParameterNotSet,
  DistinctCategories,
  InternalParameterNotSet,
  InvalidComboChoice,
  InvalidModifierItemCount,
  InvalidModifierItemDuplicateCount,
  InvalidModifierValue,
  InvalidParameterValue,
  IrremovableModifierItem,
  MissingParameters,
  MissingValue,
  ModifierItemNotAvailable,
  ModifierNotFound,
  ModifierNotSet,
  PackagingContainerNotFound,
  ParameterChoiceNotAvailable,
  ParameterNotFound,
  ParametricError,
  ProductNotAvailable,
  ProductNotFound,
  TooManyParts,
  VariantNotAvailable,
  decodeCartComboElementKey,
  decodeCartComboKey,
  decodeCartProductKey,
  decodeCartProductPartKey,
  decodeFatalError,
  decodeSimpleParametricEvaluationError,
  decodeSoftError,
  encodeCartComboElementKey,
  encodeCartComboKey,
  encodeCartProductKey,
  encodeCartProductPartKey,
  encodeFatalError,
  encodeSimpleParametricEvaluationError,
  encodeSoftError,
  eqCartComboElementKey,
  eqCartComboKey,
  eqCartProductKey,
  eqCartProductPartKey,
  eqFatalError,
  eqSimpleParametricEvaluat,
  eqSoftError,
  genericCartComboElementKey,
  genericCartComboKey,
  genericCartProductKey,
  genericCartProductPartKey,
  genericFatalError,
  genericSimpleParametricEvaluationError,
  genericSoftError,
  hasFieldCartComboElementK,
  hasFieldCartComboKey,
  hasFieldCartProductKey,
  hasFieldCartProductPartKe,
  newtypeCartComboElementKe,
  newtypeCartComboKey_,
  newtypeCartProductKey_,
  newtypeCartProductPartKey,
  ordCartComboElementKey,
  ordCartComboKey,
  ordCartProductKey,
  ordCartProductPartKey,
  showCartComboElementKey,
  showCartComboKey,
  showCartProductKey,
  showCartProductPartKey,
  showFatalError,
  showSimpleParametricEvaluationError,
  showSoftError,
  unscrambleDecodeCartComboElementKey,
  unscrambleDecodeCartComboKey,
  unscrambleDecodeCartProductKey,
  unscrambleDecodeCartProductPartKey,
  unscrambleDecodeFatalError,
  unscrambleDecodeSimpleParametricEvaluationError,
  unscrambleDecodeSoftError
};
